/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { DeleteOutputType, EntitySubscribeType } from '@/infra/appsync';
import type { SleepJson } from '@/types/domain/sleep/entities/sleepEntity';
import type { SleepStateType } from '@/types/domain/sleep/redux';
import type {
  PayloadAction,
} from '@reduxjs/toolkit';

import { service } from '@/share';

const initialState: SleepStateType = {
  sleepList: [],
  nextToken: null,
};

/**
 * 睡眠Slice
 */
export const sleepSlice = createSlice({
  name: 'sleep',
  initialState,
  reducers: {
    /** 睡眠リストをセット */
    setSleepList:
      (state, action: PayloadAction<{
        nextToken: string,
        items: SleepJson[],
      }>) => {
        state.sleepList = action.payload.items;
        state.nextToken = action.payload.nextToken;
      },
    /** 睡眠ストア作成 */
    createSleepStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.sleepList = service.sleep.createSleepStore(
        state.sleepList,
        action.payload,
        undefined,
      );
    },
    /** 睡眠ストア更新 */
    updateSleepStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.sleepList = service.sleep.updateSleepStore(
        state.sleepList,
        action.payload,
      );
    },
    /** 睡眠ストア削除 */
    deleteSleepStore: (state, action: PayloadAction<DeleteOutputType>) => {
      state.sleepList = service.sleep.deleteSleepStore(
        state.sleepList,
        action.payload,
      );
    },
  },
});
